import CryptoJS from "crypto-js";
import FETCH_API from "../config/fetch_api";
import { showLog } from "./log";
import { keyEncryption } from "../Constants";

let encryptionKey = null;

export async function initEncryptionKey() {
  try {
    const response = await FETCH_API("encryption/encryptMobile", {
      stringToEncrypt: "abc",
    });

    if (response.status === "SUCCESS") {
      encryptionKey = response.encryptedString;
      showLog('response encrypt', encryptionKey)
    }
  } catch (error) {
    console.error("Gagal mendapatkan string encrypt:", error);
  }
}

export async function initDecryptionKey() {
  try {

    if (!encryptionKey) {
      console.warn("encryptionKey masih null");
      return;
    }

    const response = await FETCH_API("encryption/decryptMobile", {
      encryptedString: encryptionKey,
    });

    if (response.status === "SUCCESS") {
      showLog("response decrypt", response);
    }
  } catch (error) {
    console.error("Gagal mendapatkan string decrypt:", error);
  }
}

export function encrypt(data) {
  if (!data) return data;
  const key = keyEncryption;

  return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
}

export function decrypt(data) {
  if (!data || !encryptionKey) {
    return null;
  }

  try {
    const key = keyEncryption;

    const bytes = CryptoJS.AES.decrypt(data, key);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    if (!decrypted) {
      return null;
    }

    console.log('encrypted data', data);
    console.log('used key', key);
    console.log('decrypted data', decrypted);

    return JSON.parse(decrypted);
  } catch (error) {
    return null;
  }
}


// import CryptoJS from "crypto-js";
// import { showLog } from "./log";

// export const encrypt = (data) => {
//   showLog("Encrypt Masuk encrypt");
//   if (data) {
//     var ciphertext = CryptoJS.AES.encrypt(
//       JSON.stringify(data),
//       "KBa2HxRmxi7i4v6dUa0bFAmRGbN0ACAi9t3ExsNY4svgoz7YMbBXiCHJ6QiW1MFE"
//     ).toString();
//     return ciphertext;
//   } else {
//     return data;
//   }
// };

// export const decrypt = (data) => {
//   showLog("Encrypt Masuk decrypt");
//   if (data) {
//     var bytes = CryptoJS.AES.decrypt(
//       data,
//       "KBa2HxRmxi7i4v6dUa0bFAmRGbN0ACAi9t3ExsNY4svgoz7YMbBXiCHJ6QiW1MFE"
//     );
//     var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//     return decryptedData;
//   } else {
//     return data;
//   }
// };